module.exports = __webpack_public_path__ + "img/guardian_buff_cross.86f15e6e.png";